import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';

import { Sacado } from '../_models/sacado/sacado';
import { FilterSacado } from '../_models/filter/FilterSacado';
import { Observable } from 'rxjs';
import { Cedente } from '../_models/cedente/cedente';

export const HTTP_OPTIONS = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Access-Control-Allow-Credentials' : 'true',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE, PUT, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
  })
};

@Injectable({ providedIn: 'root' })
export class SacadoService {
  constructor(private http: HttpClient) { }

   getSacado(filterSacado: FilterSacado): Observable<any> {
        return this.http.post<Sacado[]>(`${environment.authorizedUrls.bsCobrancaUrl}/sacado/listFiltro`, {
        filterSacado,
      });
    }

    getAllByCedente(documento: string) {
      return this.http.get<Sacado[]>(`${environment.authorizedUrls.bsCobrancaUrl}/sacado/listarTodosPorCedente/` + documento);
    }

    getSacadoPorDocumento(documento: string): Observable<Sacado> {
       return this.http.get<Sacado>(`${environment.authorizedUrls.bsCobrancaUrl}/sacado/findSacado/` + documento);
    }

    getAllBySacado() {
      return this.http.get<Sacado[]>(`${environment.authorizedUrls.bsCobrancaUrl}/sacado`);
    }

    findByCedente(codEmpresa: number) {
      return this.http.get<Cedente[]>(`${environment.authorizedUrls.bsCobrancaUrl}/sacado/findByCedente/` + codEmpresa);
    }

    findByCedenteId(codCedente: number) {
      return this.http.get<Cedente[]>(`${environment.authorizedUrls.bsCobrancaUrl}/sacado/findByCedenteId/` + codCedente);
    }

    findByCedenteCodInscricao(CodInscricao: string) {
      return this.http.get<Cedente[]>(`${environment.authorizedUrls.bsCobrancaUrl}/sacado/findByCedenteCodInscricao/` + CodInscricao);
    }

    exportarRelatorioSacados(filterSacado: FilterSacado){
      return this.http.post(`${environment.authorizedUrls.bsCobrancaUrl}/sacado/exportarSacados`, {
        filterSacado
      }, {responseType: 'blob' as 'json'})
  
    }

}
